import { types } from '../types'

const initialState = {
    displayLngModal: false,
    selectedChartFilter: 'week',
    displayUserRecognition: false,
    groupedMessages: new Map(),
    menuSettings: null,
    domainFiles: []
}

const commonReducer = (state = initialState, { type, isShow, filter, chat, userId, user, menuSettings, data,status }) => {
    switch (type) {


        case types.SET_DISPLAY_SWITCH_LNG_MODAL: {
            return {
                ...state,
                displayLngModal: isShow
            }
        }

        case types.SET_CHART_FILTER: {
            return {
                ...state,
                selectedChartFilter: filter
            }
        }

        case types.SET_DOMAIN_FILTER: {
            return {
                ...state,
                selectedDomainFilter: filter
            }
        }
        case types.RECOGNIZE_USER_SWITCH: {
            return {
                ...state,
                displayUserRecognition: isShow,
                userToRecognition:user
            }
        }

        case types.SET_MENU_SETTINGS: {
            return {
                ...state,
                menuSettings: menuSettings
            }
        }

        case types.SET_DOMAIN_FILES: {
            return {
                ...state,
                domainFiles: data
            }
        }


        case types.SET_SIGN_OUT: {
            return {
                ...state,
                displaySignout: isShow
            }
        }


        case types.SET_USER_INFO_TO_RECOGNITIONS_SUCCESS: {
            return {
                ...state,
                successRecognitions: status
            }
        }

       

    

        default:
            return state
    }
}

export default commonReducer;